import { gql } from '@apollo/client';

export const FILTERING_RULE_GROUPS_PAGE_QUERY = gql`
  query filteringRuleGroups(
    $limit: Int!
    $offset: Int!
    $withDeleted: Boolean
    $q: String
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    filteringRuleGroups(
      limit: $limit
      offset: $offset
      withDeleted: $withDeleted
      q: $q
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      name
      deletedAt
    }
    filteringRuleGroupsPageInfo(q: $q, columnFilters: $columnFilters, withDeleted: $withDeleted) {
      totalCount
    }
  }
`;

export const FILTERING_RULE_GROUPS_QUERY = gql`
  query filteringRuleGroups($limit: Int!, $offset: Int!, $q: String, $withDeleted: Boolean) {
    filteringRuleGroups(limit: $limit, offset: $offset, q: $q, withDeleted: $withDeleted) {
      id
      name
      deletedAt
    }
  }
`;

export const FILTERING_RULE_GROUP_QUERY = gql`
  query filteringRuleGroup($id: Int!) {
    filteringRuleGroup(id: $id) {
      id
      name
      groupRule
      filteringRules {
        id
        scope
        field
        op
        value
      }
      deletedAt
    }
  }
`;
